import { Injectable } from "@angular/core";
import { HttpClient } from "../shared/wrappers/HttpClient";
import { ToastsManager } from "ng2-toastr";
import { ErrorHandlerProvider } from "../shared/providers/errorHandler.provider";
import { DropDownList } from "../models/DropDownList.model";
import { CommonHelper } from "../shared/helpers/CommonHelper";
import { LegalCertificate } from "../models/legalCertificate.model";
import { UrlBuilder } from "../models/utils/url-builder.model";

@Injectable()
export class LegalCertificateService {
    constructor(private httpClient: HttpClient,
                public toastr: ToastsManager,
                private errorHandler: ErrorHandlerProvider) { }

    endPoint: String = "/legal-certificates";

    async searchLegalCertificate(legalCertificateSearch): Promise<LegalCertificate[]> {

        const builder = new UrlBuilder([
            { key: "skip", value: legalCertificateSearch.skip },
            { key: "limit", value: legalCertificateSearch.limit }])

        var keyValueParams = [];

        if(legalCertificateSearch.name)
            keyValueParams.push({ key: "name", value: legalCertificateSearch.name });

        if (legalCertificateSearch.startDate)
            keyValueParams.push({ key: "startDate", value: legalCertificateSearch.startDate });

        if (legalCertificateSearch.endDate)
            keyValueParams.push({ key: "endDate", value: legalCertificateSearch.endDate });

        for (let types of legalCertificateSearch.type)
            keyValueParams.push({ key: "type", value: types });

        for (let owners of legalCertificateSearch.owner)
            keyValueParams.push({ key: "owner", value: owners });

        builder.addEncodedQueryStringParamsInsideFilter(keyValueParams);

        const response = await this.httpClient.get(builder.buildUrl(`${this.endPoint}/search`));

        legalCertificateSearch.totalItems = response.totalItems;
        legalCertificateSearch.totalValue = response.totalValue;

        return response.legalCertificates
    }

    createPropertyObjDropDown(arrayValue: any, single: boolean = false, name: string, pluralName: string, params = [], groupBy = null) {
        let obj = {
            dropDownList: new Array<DropDownList>(),
            selectedItems:new Array<DropDownList>(),
            dropDownSettings: {},
            commonHelper: new CommonHelper()
        }
        obj.dropDownList = obj.commonHelper.getDropDownListItems(arrayValue, "_id", "name", params);
        obj.dropDownSettings = obj.commonHelper.getDropDownSettings(single, name, false, `Marcar todos os ${pluralName}`, `Desmarcar todos os ${pluralName}`, true,groupBy, '');
        return obj;
    }

    async update(legalCertificate: LegalCertificate){
        return await this.httpClient.update(this.endPoint, legalCertificate._id, legalCertificate)
    }

    async create(legalCertificate: LegalCertificate) {
        return await this.httpClient.post(this.endPoint, legalCertificate);
    }

    async getById(id): Promise<LegalCertificate> {
        const response = await this.httpClient.get(`${this.endPoint}/${id}`);
        const certificateToEdit = new LegalCertificate(response);
        return certificateToEdit;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/legalCertificate.service.ts